import { Box, Typography } from "@mui/material";

type Props = {
  date: Date;
};

export default function TimelineDateMarker({ date }: Props) {
  return (
    <Box
      sx={{
        pb: 1,
        textAlign: "center",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
        }}
      >
        {new Intl.DateTimeFormat(navigator.language, {
          month: "long",
          day: "numeric",
        }).format(date)}
      </Typography>
    </Box>
  );
}
